import {
  Link,
  Outlet,
  createFileRoute,
} from '@tanstack/react-router';

import { Text } from '@/components/ui/text';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';

export const Route = createFileRoute('/design-system')({
  component: DesignSystemLayout,
});

const NAV: ReadonlyArray<{ to: string; label: string }> = [
  { to: '/design-system', label: 'Overview' },
  { to: '/design-system/tokens', label: 'Tokens' },
  { to: '/design-system/components', label: 'Components' },
  { to: '/design-system/icons', label: 'Icons' },
  { to: '/design-system/brand', label: 'Brand' },
];

function DesignSystemLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <header className="sticky top-0 z-30 flex h-14 items-center justify-between border-b border-border bg-card/95 px-6 backdrop-blur supports-backdrop-filter:bg-card/80">
        <Link
          to="/design-system"
          className="flex items-center gap-2 text-foreground"
        >
          <img
            src="/logo-mark.svg"
            alt=""
            aria-hidden
            className="size-7 text-foreground"
          />
          <Text variant="headline" as="span">
            Lights Planner
          </Text>
          <Text variant="caption" tone="muted" as="span" className="ml-1">
            Design system
          </Text>
        </Link>
        <nav className="hidden items-center gap-1 sm:flex">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} label={item.label} />
          ))}
        </nav>
      </header>
      <nav className="flex items-center gap-1 overflow-x-auto border-b border-border bg-card px-6 py-2 sm:hidden">
        {NAV.map((item) => (
          <NavLink key={item.to} to={item.to} label={item.label} />
        ))}
      </nav>
      <main className="mx-auto w-full max-w-6xl px-6 py-10">
        <Outlet />
      </main>
      <Separator />
      <footer className="mx-auto w-full max-w-6xl px-6 py-6">
        <Text variant="caption" tone="muted">
          Mirrors src/styles/index.css and src/components/ui/*. Renders the real
          primitives — what you see is what ships.
        </Text>
      </footer>
    </div>
  );
}

function NavLink({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      activeOptions={{ exact: to === '/design-system' }}
      className={cn(
        'inline-flex h-7 items-center rounded-md px-2 text-sm text-muted-foreground transition-colors',
        'hover:bg-muted hover:text-foreground',
      )}
      activeProps={{ className: 'bg-muted text-foreground' }}
    >
      {label}
    </Link>
  );
}
